<div class="c-modal__inner">
  <div *ngIf="!isLoading; else loading" class="c-modal__form c-form c-form--d">
    <div class="c-modal__head">
      <div class="row">
        <div class="c-modal__close" (click)="close()">
          <p500-ui-icon name="controls-close" size="24px"></p500-ui-icon>
        </div>
        <div class="c-modal__title col-12" i18n="@@common.enter_2fa_code">Enter 2FA Code</div>
        <div class="c-modal__subtitle col-12" i18n="@@common.enter_2fa_code_unsecure">Enter 2FA code For Unsecured Mode</div>
      </div>
    </div>

    <div class="c-modal__body">
      <p500-ui-cube-preloader [hidden]="!isLoading"></p500-ui-cube-preloader>
      <div class="c-modal__description" i18n="@@common.2fa_unsecure_hint">
        You will see the secured data in the Key Info column. Data will be hidden after 30 minutes for security reasons.
      </div>

      <div class="row">
        <div class="c-form__section col-12">
          <p500-ui-text-field label="2FA" [formControl]="tokenControl" [placeholder]="placeholder"></p500-ui-text-field>
        </div>
      </div>

      <button
        p500-ui-button-icon
        iconName="control-refresh-bold"
        color="primary"
        size="xsmall"
        class="c-modal__send-button mb-12"
        type="button"
        (click)="resendCode()"
      >
        <span class="text" i18n="@@common.send_the_code_again">Send the code again</span>
      </button>
    </div>

    <div class="c-modal__footer">
      <div class="c-modal__action" (click)="close()">
        <button p500-ui-button stroked="true" type="button">Cancel</button>
      </div>

      <div class="c-modal__action">
        <button
          p500-ui-button
          classIcon="p500-ui-icon-check"
          positionIcon="right"
          type="submit"
          i18n="@@common.submit"
          [disabled]="!tokenControl.valid || isLoading"
          (click)="submit()"
        >
          Submit
        </button>
      </div>
    </div>
  </div>

  <ng-template #loading>
    <form class="c-modal__form c-form c-form--d">
      <div class="c-modal__head">
        <div class="row">
          <div class="c-modal__close" (click)="close()">
            <p500-ui-icon name="controls-close" size="24px"></p500-ui-icon>
          </div>
          <div class="c-modal__title col-12" i18n="@@common.enter_2fa_code">Enter 2FA Code</div>
          <div class="c-modal__subtitle col-12" i18n="@@common.enter_2fa_code_unsecure">Enter 2FA code For Unsecured Mode</div>
        </div>
      </div>

      <div class="c-modal__body">
        <p500-ui-cube-preloader></p500-ui-cube-preloader>
      </div>

      <div class="c-modal__footer">
        <div class="c-modal__action" (click)="close()">
          <button p500-ui-button stroked="true" type="button" i18n="@@common.cancel">Cancel</button>
        </div>

        <div class="c-modal__action">
          <button p500-ui-button classIcon="p500-ui-icon-check" positionIcon="right" type="submit" i18n="@@common.submit" [disabled]="true">
            Submit
          </button>
        </div>
      </div>
    </form>
  </ng-template>
</div>
